import { ImageProfile } from "./image-profile.component";

export default ImageProfile;
